import React from "react";
import { motion } from "framer-motion";
import { Home, Building2, KeyRound, MapPin, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const services = [
  {
    icon: <Home className="w-10 h-10 text-gray-800 mb-4" />,
    title: "Buy Property",
    desc: "Discover verified RERA-approved properties — from luxury apartments to affordable homes.",
    img: "https://images.unsplash.com/photo-1570129477492-45c003edd2be?auto=format&fit=crop&w=800&q=60",
  },
  {
    icon: <Building2 className="w-10 h-10 text-gray-800 mb-4" />,
    title: "Sell Property",
    desc: "We help you sell your property fast with expert marketing, transparent pricing, and legal support.",
    img: "/uploads/sell.jpeg",
  },
  {
    icon: <KeyRound className="w-10 h-10 text-gray-800 mb-4" />,
    title: "Rental Services",
    desc: "Get verified tenants and reliable rental management services without hassle or hidden fees.",
    img: "/uploads/rental.jpg",
  },
  {
    icon: <MapPin className="w-10 h-10 text-gray-800 mb-4" />,
    title: "Investment Advice",
    desc: "We guide you on prime investment opportunities with excellent connectivity and long-term location potential.",
    img: "/uploads/advice.jpeg",
  },
];

const Services = () => {
  return (
    <div className="bg-gray-50 min-h-screen pt-10">
    {/* ======= SERVICES SECTION (Unified Color Theme) ======= */}
<section className="bg-gradient-to-br from-gray-50 via-white to-blue-50 py-24 px-6">
  <div className="max-w-7xl mx-auto text-center mb-16">
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
        Our <span className="text-blue-600">Services</span>
      </h1>
      <p className="max-w-2xl mx-auto text-gray-600 text-lg">
        Providing professional real estate services — buying, selling, renting,
        and investing — built on trust, transparency, and experience.
      </p>
    </motion.div>
  </div>

  {/* ======= SERVICES FLEX CARDS ======= */}
  <div className="flex flex-wrap justify-center gap-10">
    {services.map((service, i) => (
      <motion.div
        key={i}
        className="bg-white w-full sm:w-[45%] lg:w-[22%] rounded-xl overflow-hidden shadow-md hover:shadow-xl transition transform hover:-translate-y-2 border border-gray-200 flex flex-col"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: i * 0.1 }}
      >
        {/* Image */}
        <div className="h-44 w-full overflow-hidden">
          <motion.img
            src={service.img}
            alt={service.title}
            className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
          />
        </div>

        {/* Content */}
        <div className="p-6 text-center flex flex-col flex-grow justify-between">
          <div className="flex flex-col items-center">
            {React.cloneElement(service.icon, { className: "w-10 h-10 text-blue-600 mb-4" })}
            <h3 className="text-lg font-semibold text-gray-800 mb-2">
              {service.title}
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed">{service.desc}</p>
          </div>
        </div>
      </motion.div>
    ))}
  </div>
</section>

      {/* ======= CTA SECTION ======= */}
      <section className="bg-gray-900 text-white py-20 px-6 text-center">
        <motion.h2
          className="text-3xl font-bold mb-4"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          Let’s Find Your Perfect Space
        </motion.h2>
        <p className="max-w-2xl mx-auto mb-8 text-gray-300">
          Whether you’re buying your first home or planning an investment,
          Thakkar Realtors will guide you every step of the way.
        </p>
        <Link to="/contact">
          <motion.button
            className="bg-white text-gray-900 px-8 py-3 rounded-xl font-semibold hover:bg-gray-100 transition flex items-center justify-center gap-2 mx-auto shadow-sm"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.97 }}
          >
            Contact Us
            <ArrowRight className="w-5 h-5 text-gray-700" />
          </motion.button>
        </Link>
      </section>
    </div>
  );
};

export default Services;
